import { OnInit, EventEmitter } from '@angular/core';
import { AngularFireStorage, } from 'angularfire2/storage';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { AngularFirestore } from 'angularfire2/firestore';
import * as MidiConvert from 'midiconvert';
import WaveSurfer from 'wavesurfer.js';
import * as $ from 'jquery';
var FileUploadComponent = /** @class */ (function () {
    function FileUploadComponent(storage, db) {
        this.storage = storage;
        this.db = db;
        // Sends the URL to the Home Component
        this.fileUrl = new EventEmitter();
        // Sends the MIDI data to the Home Component
        this.midiDataJSON = new EventEmitter();
        // File sizes for filtering
        this.fileSizes = [10, 100, 1000, 10000, 100000, 10000000, 10000000000];
        // WaveSurfer library variable
        this.wavesurfer = { isPlaying: function () { }, getMute: function () { } };
        // Boolean variable for if play buttons are hovered
        this.hoveredWSB = false;
        // Boolean variable for if wavesurfer has loaded the file
        this.wavesurferLoaded = new Observable(function (subscriber) {
            subscriber.next(true);
            // subscriber.complete();
        });
    }
    FileUploadComponent.prototype.toggleHover = function (event) {
        this.isHovering = event;
    };
    FileUploadComponent.prototype.startUpload = function (event, folder) {
        var _this = this;
        // The File object
        var file = event.item(0);
        // Client-side validation for files
        if ((file.type.split('/')[0] === 'audio' &&
            (file.type.split('/')[1] === 'mid' ||
                file.type.split('/')[1] === 'midi' ||
                file.type.split('/')[1] === 'x-midi') &&
            folder === 'MIDI') ||
            (file.type.split('/')[0] === 'audio' && folder === 'Vocal')) {
            console.log('File Type: ', file.type);
        }
        else {
            console.error('Unsupported File Type! \n MIDI File Expected. But got "' +
                file.type +
                '" instead.');
            return;
        }
        // The storage path
        var path = folder + "/" + new Date().getTime() + "_" + file.name;
        // Totally optional metadata
        var customMetadata = { app: 'My AngularFire-Powered MAT!' };
        // The main task
        this.task = this.storage.upload(path, file, { customMetadata: customMetadata });
        // The file name
        this.name = file.name;
        // Progress monitoring
        this.percentage = this.task.percentageChanges();
        this.snapshot = this.task.snapshotChanges();
        // The file's download URL
        this.task
            .snapshotChanges()
            .pipe(finalize(function () { return (_this.downloadURL = _this.storage.ref(path).getDownloadURL()); }))
            .subscribe();
        this.snapshot = this.task.snapshotChanges().pipe(tap(function (snap) {
            if (snap.bytesTransferred === snap.totalBytes) {
                // Update firestore on completion
                _this.db.collection(folder).add({ path: path, size: snap.totalBytes });
            }
        }));
    };
    // Loads Midi Data
    FileUploadComponent.prototype.loadMidiData = function (url) {
        MidiConvert.load(url, function (midi) {
            $('#midiContent').html(JSON.stringify(midi));
            return midi;
        });
    };
    // Loads Vocal Data
    FileUploadComponent.prototype.loadVocalData = function (url) {
        var _this = this;
        this.fileUrl.emit(url);
        this.midiDataJSON.emit($('#midiContent').html());
        $('#waveform').html('');
        this.wavesurfer = WaveSurfer.create({
            container: '#waveform',
            waveColor: '#455a64',
            progressColor: '#FFD183',
            cursorColor: '#43A047',
            responsive: true,
            autoCenter: true,
        });
        this.wavesurfer.on('error', function (err) {
            console.log(err);
        });
        this.wavesurfer.load(url);
        this.wavesurfer.on('ready', function () {
            _this.wavesurferLoaded.subscribe();
        });
    };
    // Reveals next button for Steps
    FileUploadComponent.prototype.revealNext = function (i) {
        $('#next' + i).show();
    };
    // Determines if the upload task is active
    FileUploadComponent.prototype.isActive = function (snapshot) {
        return (snapshot.state === 'running' &&
            snapshot.bytesTransferred < snapshot.totalBytes);
    };
    // Toggles an Element's Visibility
    FileUploadComponent.prototype.toggleElementVisibility = function (id) {
        $('#' + id).toggle('slow');
    };
    FileUploadComponent.prototype.ngOnInit = function () { };
    return FileUploadComponent;
}());
export { FileUploadComponent };
